//LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const TipologySearchSection: React.FC = () => {
    const { t } = useTranslation();

    const searchCategories = [
        {
            text: t('homePage.searchForTypo.typology1Text'),
            imgPath: "/assets/images/inHome/categories/appartamento.jpg",
            link: "immobili/appartamento"
        },
        {
            text: t('homePage.searchForTypo.typology2Text'),
            imgPath: "/assets/images/inHome/categories/villa.jpg",
            link: "immobili/villa"
        },
        {
            text: t('homePage.searchForTypo.typology3Text'),
            imgPath: "/assets/images/inHome/categories/villetteschi.jpg",
            link: "immobili/villetta-a-schiera"
        },
        {
            text: t('homePage.searchForTypo.typology4Text'),
            imgPath: "/assets/images/inHome/categories/attico.jpg",
            link: "immobili/attico"
        },
        {
            text: t('homePage.searchForTypo.typology5Text'),
            imgPath: "/assets/images/inHome/categories/casale.jpg",
            link: "immobili/?tipologia=10&tipologia=73"
        },
        {
            text: t('homePage.searchForTypo.typology6Text'),
            imgPath: "/assets/images/inHome/categories/negozio.jpg",
            link: "immobili/attivita-commerciale"
        }
    ]
        
    return (
        <section id="searchForTipology" className="space-ptb">
            <div className="container-fluid">
                <p className="mb-2 sub-title">{t('homePage.searchForTypo.subTitle')}</p>
                <h2 className="mb-3">{t('homePage.searchForTypo.title')}</h2>
                <div className="row">
                    {searchCategories.map(( category, index) => (
                        <div className="col-12 col-lg-6 col-xl-4 mb-0 mb-lg-3" key={index}>
                            <Link to={category.link} className="category-card" title={category.text}>
                                <img src={category.imgPath} className="img-fluid" alt={`${t('homePage.searchForTypo.altIntro') + category.text }`} />
                                <p className="text-center m-0">{category.text}</p>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default TipologySearchSection;
